import 'css-chunksrc/client/pages/searchPage/loader/element/styles.scss';export default {
  "element": "_element_16yv7_2",
  "icon": "_icon_16yv7_11",
  "main": "_main_16yv7_19",
  "header": "_header_16yv7_23",
  "name": "_name_16yv7_31",
  "zone": "_zone_16yv7_37",
  "project": "_project_16yv7_45",
  "projectIcon": "_projectIcon_16yv7_53",
  "projectName": "_projectName_16yv7_61",
  "footer": "_footer_16yv7_68"
};